import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { Subscription } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';


@Component({
  selector: 'miradi-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    DialogModule,
    TranslateModule,
  ],
})
export class SessionExpiredDialogComponent implements OnInit, OnDestroy {

  recovery = false;
  visible = false;

  private subscription: Subscription;

  constructor(
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.subscription = this.authService.sessionExpired$.subscribe({
      next: () => {
        // Repeated re-auths have come back unauthenticated, so offering the same
        // sign-in again would just loop; offer starting over instead.
        this.recovery = this.authService.signInLooping;
        this.visible = true;
        this.cdr.markForCheck();
      },
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  reset() {
    this.authService.resetSignIn();
  }

  signIn() {
    this.authService.reauthenticate();
  }

}
